import AccountConsolidation from '@/pages/sales-rep/AccountConsolidation';
import MarginCalculator from '@/pages/sales-rep/margin-calculator/MarginCalculator';
import UploadETA from '@/pages/sales-rep/uploadETA/UploadETA';
import NewAccountFormView from '@/pages/sales-rep/new-account-form/NewAccountFormView';
import FiscalYear from '@/pages/sales-rep/fiscal-year/FiscalYear';
import UploadSalesFile from '@/pages/sales-rep/sales-file/UploadSalesFile';
import EstimateArrivalReport from '@/pages/sales-rep/downloadETA/EstimateArrivalReport';
import BiCustomer from '@/pages/sales-rep/bi-customer/BiCustomer';

const salesRepRoutes = [
  { path: 'bireport-accountConsolidation', element: AccountConsolidation },
  { path: 'marginCalculator', element: MarginCalculator },
  { path: 'bireport-EstimatedFileUpload', element: UploadETA },
  { path: 'new-account-form', element: NewAccountFormView },
  { path: 'bireport-fiscalYear', element: FiscalYear },
  { path: 'uploadsalesreport', element: UploadSalesFile },
  { path: 'bireport-estimatedArrivalReport', element: EstimateArrivalReport },
  { path: 'bicustomers', element: BiCustomer },
];

export default salesRepRoutes;
